import { defineStore } from 'pinia'
import Logging from '@serv/Logging'
import Request from '@serv/Request'
import { computed, ref } from 'vue'

export const useClinicalCodesStore = defineStore('clinicalCodes', () => {
    const clinicalCodes = ref([])
    const hasClinicalCodes = computed(() => clinicalCodes.value.length > 0)

    const getClinicalCodesBySlugs = (slugs) => {
        if (!hasClinicalCodes.value) {
            return []
        }

        return clinicalCodes.value.filter(clinicalCode => slugs.includes(clinicalCode.slug))
    }

    const fetchClinicalCodes = async () => {
        if (hasClinicalCodes.value) {
            return []
        }

        try {
            const response = await Request.get(Request.Stem.clinicalCodes)
            clinicalCodes.value = response.data

            return clinicalCodes.value
        } catch (err) {
            Logging.warn(`Failed to fetch clinical codes: ${err}`)
        }
    }

    /* Clear everything in state */
    const $reset = () => {
        clinicalCodes.value = []
    }

    return {
        $reset,
        clinicalCodes,
        hasClinicalCodes,
        getClinicalCodesBySlugs,
        fetchClinicalCodes
    }
})
